//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
    system,
    getUserInfo,
    isApp,
    shareFun,
    toggleTopbar,
    switchNavColor,
    callApp,
    controlTopButton,
    logEventStatistics,
    pageViewStatistics
} from '@/util/const'

export default {
    name: "lucky",
    data() {
        return {
            lang: '',
            num3: {
                left: this.$t('lucky.topUp.t5'),
                right: this.$t('lucky.topUp.t6')
            },
        }
    },
    methods: {
        jumpUrl() {
            logEventStatistics({
                umkey: 'refill_to_share_click',
            })
            setTimeout(() => {
                // window.location.href = 'cmcchkh5action://close'
                // window.location.href = 'cmcchkhsh://prepaidCardValueAdded'
                window.location.href = 'openhkhshlogin://cmcchkhsh://prepaidCardValueAdded'
            }, 100)
        },
    },
    created() {
        this.lang = window.localStorage.lang
    }
}



// WEBPACK FOOTER //
// ./src/page/topUp.vue